<div class="row">
    <div class="col-12 bot-role-container">
        <div *ngIf="saving" class="saving-overlay"><i class="far fa-spin fa-spinner-third"></i></div>
        <div class="bot-mapping-new-design {{ bot.botType === 'internal' ? 'condensed' : ''}}">
            <div class="nested-bot-service-container">
                <div class="data-mapping-flow-container">
                    <ng-container
                            *ngFor="let mapBoard of mappingBoards; let i = index;">
                        <mapping-board
                                [mappingBoard]="mapBoard"
                                [serviceId]="serviceId"
                                [checkingNewServiceLinks]="checkingNewServiceLinks"
                                [showDatabases]="{value: true}"
                                [flexRemoteDatabases]="true"
                                [muleServices]="muleServices"
                                [allServices]="allServices"
                                [allServiceFields]="allServiceFields"
                                [internalAllServiceFields]="internalAllServiceFields"
                                [fieldGroups]="allFieldGroups"
                                [internalFieldGroups]="internalAllFieldGroups"
                                [bot]="bot"
                                [selectedMuleService]="selectedMuleService"
                                [checkingVisibility]="checkingVisibility"
                                [hideFormFields]="mapBoard.type === 'input' ? hideInputFormFields : hideOutputFormFields"
                                [fields]="this.selectedMuleService && this.fields[this.selectedMuleService.id] ? this.fields[this.selectedMuleService.id][i.toString()] : (bot.botType === 'internal' ? allFieldGroups : [])"
                                [rightFields]=""
                                [hideFields]="mapBoard.type === 'input' ? hideInputFields : hideOutputFields"
                                [generateRightEstructure]="generateRightEstructure"
                                (handleScroll)="handleScroll(mapBoard.id)"
                                (updateHiddenServiceFields)="updateHiddenServiceFields()"
                                (updateRelationshipsPositions)="updateRelationshipsPositions()"
                                (setSelectedMuleService)="setSelectedMuleService($event)"
                                (saveLines)="saveLines($event)"
                                (setBoardVisibility)="setBoardVisibility($event)"
                                (setBotService)="setBotService($event)"
                                (changeBotService)="changeBotService($event)"
                                (updateLinesVisibility)="checkLinesVisibility(mapBoard.id)"
                                (itemDrop)="itemDrop(mapBoard.id)"
                                (addDataTransformation)="onAddDataTransformation($event)"
                                (showLines)="showLines();"
                                (hideLines)="hideLines();"
                                (askToOpenEntriesFilters)="openEntriesFilters($event)"
                                (saveQueryEvent)="updateQueryFilter($event)"
                        ></mapping-board>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<data-transformations
    *ngIf="showDataTransformationDrawer"
    class="data-trasnformation-layer"
    [switchs]="transformationSwitchs"
    (closeLayer)="hideDrawer()"
    [serviceId]="serviceId"
    [selectedLink]="selectedLink"
    (saveTransformation)="saveTransformation($event)"
    ></data-transformations>

<entries-filters
    *ngIf="tempSelectedBoard"
    [serviceId]="serviceId"
    (showLines)="showLines();"
    (hideLines)="hideLines();"
    (saveEntriesFilters)="updateDeterminantFilter($event)"
    [filters]="tempSelectedBoardFilters">
</entries-filters>